import React, { useEffect, useState } from 'react'
import Moment from 'moment'
import { 
  Row,
  Col,
  Modal, 
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form, FormText, FormGroup, Label, Input
} from 'reactstrap'
import _ from 'lodash'
import DatePicker from 'react-datepicker'
import LoadingOverlay from 'components/Indicator/LoadingOverlay'

import { LanguagesDefaultValue, LanguagesFieldData } from '../../assets'

const FormContent = ({
  open,
  onLoadLanguage,
  
  onClose,
  selectedFormData,
  onClickSubmit
}) => {

  const [ languageFormData, onChangeLanguageData ] = useState( LanguagesDefaultValue )

  useEffect(() => { 
    if ( !open ){
      onChangeLanguageData( LanguagesDefaultValue )
    }
  }, [open])

  useEffect(() => {
    onChangeLanguageData( selectedFormData )
  }, [ selectedFormData ])

  const onChangeLanguageField = ( key, val ) => {
    let tmp = _.cloneDeep( languageFormData )
    tmp[ key ] = val
    return onChangeLanguageData( tmp )
  }

  return (
    <Modal
      isOpen={ open }
      size={ 'xl' }>
      <ModalHeader toggle={() => onClose()}>{ `Edit Language` }</ModalHeader>
      <ModalBody>
        <i className={ 'font-weight-bold' }>
          <span className={ 'text-danger' }>* </span>
          <u>indicates required field</u>
        </i>
        <Form className={ 'mt-3'} onSubmit={ e => e.preventDefault()}>
          <Row>
          {
            LanguagesFieldData.map( item => (
              <Col key={ item.value } lg={ item.col || 12 }>
                <FormGroup>
                  { 
                    item.label && (
                      <Label>
                        { `${ item.label } ` }
                        { item.required && <span className="text-danger">*</span> }
                      </Label>
                  )}
                  {
                    item.type === 'select' && (
                      <Input
                        type={ item.type }
                        value={ languageFormData[ item.value ] }
                        onChange={ e =>  onChangeLanguageField( item.value, e.target.value )}
                        >
                        <option value=""></option>
                        { 
                          item.options.map( option => (
                            <option key={ option.id } value={ option.id }>{ option.name }</option>
                          ))
                        }
                      </Input>
                    )
                  }
                  {
                    item.type !== 'select' && (
                      <Input
                        type={ item.type }
                        value={ languageFormData[ item.value ] }
                        onChange={ e => onChangeLanguageField( item.value, e.target.value )}/>
                    )
                  }
                  {
                    item.type === 'date' && (
                      <DatePicker
                        className={ 'w-100' }
                        showTimeSelect
                        dateFormat="dd-MM-yyyy h:mm aa"
                        selected={ languageFormData[ item.value ] }
                        onChange={ val => onChangeLanguageField( item.value, val )}
                      />
                    )
                  }
                  { item.subLabel && <FormText>{ item.subLabel }</FormText> }
                </FormGroup>
              </Col>
            ))
          }
          </Row>
        </Form>
        { onLoadLanguage && <LoadingOverlay/> }
      </ModalBody>
      <ModalFooter>
        <Button 
          color={ 
            (LanguagesFieldData.some( item => item.required && !languageFormData[ item.value ])) 
              ? 'secondary' 
              : 'primary' 
          }
          className="mr-2"
          disabled={ LanguagesFieldData.some( item => item.required && !languageFormData[ item.value ])}
          onClick={() => {
            onClickSubmit({
              ... languageFormData,
              spoken: +languageFormData.spoken,
              written: +languageFormData.written
            })
          }}>
          Submit
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default FormContent